import apiService from '../apiService'

export const riskScoreManagementController = (configService = {}) => {
  const service = apiService(configService)
  const url = '/cms/buyer/category_risk'
  return {
    getCategorys: params => {
      return service.get({
        url: url,
        params,
      })
    },

    getCategoryByID: id => {
      return service.get({
        url: url + `/${id}`,
      })
    },

    updateCategory: params => {
      return service.put({
        url: url,
        params,
      })
    },
  }
}
